import cloneDeep from 'lodash/cloneDeep'

import {
  ContextEditorFormValues,
  EditorFormValues,
  MessageEditorFormValues,
} from 'apps/aiAutomation/components/EngagementGoalEditor/components/LeadGenEditor/lib/types'
import { GoalStatus, GoalType, LeadGenGoal } from 'shared/api/requests/aiEngagementGoal/schemas'

export const mapGoalToContextFormValues = (goal: LeadGenGoal): ContextEditorFormValues => ({
  url: goal.data.message.button.url,
  context: goal.data.context,
})

export const mapGoalToMessageFormValues = (goal: LeadGenGoal): MessageEditorFormValues => ({
  message: goal.data.message.text,
  buttonTitle: goal.data.message.button.title,
})

export const mergeContextValuesWithGoal = (
  goal: LeadGenGoal,
  values: ContextEditorFormValues,
): LeadGenGoal => {
  const updatedGoal = cloneDeep(goal)

  updatedGoal.data.message.button.url = values.url
  updatedGoal.data.context = values.context

  return updatedGoal
}

export const mergeMessageValuesWithGoal = (goal: LeadGenGoal, values: MessageEditorFormValues) => {
  const updatedGoal = cloneDeep(goal)

  updatedGoal.data.message.text = values.message
  updatedGoal.data.message.button.title = values.buttonTitle

  return updatedGoal
}

export const createGoalFromFormValues = ({
  id,
  values,
}: {
  id: string
  values: EditorFormValues
}): LeadGenGoal => ({
  id,
  status: GoalStatus.STOPPED,
  type: GoalType.LEAD_GEN,
  ts_updated: new Date().toISOString(),
  data: {
    context: values.context,
    message: {
      text: values.message,
      button: {
        title: values.buttonTitle,
        url: values.url,
      },
    },
  },
})
